/*
 * @Author: AnNa
 * @Date: 2020-09-03 19:57:48
 * @LastEditors: AnNa
 * @LastEditTime: 2021-01-27 14:42:52
 * @Description: 
 */
export const ACCESS_TOKEN = 'Access-Token'
export const ACCESSCAI_TOKEN = 'AccessCai-Token'
export const ORDER_SYNC_TB = 'Order-Sync-tb'
export const ORDER_SYNC_JD = 'Order-Sync-jd'
export const ORDER_SYNC_PDD = 'Order-Sync-pdd'
export const SIDEBAR_TYPE = 'SIDEBAR_TYPE'
export const DEFAULT_THEME = 'DEFAULT_THEME'
export const DEFAULT_LAYOUT_MODE = 'DEFAULT_LAYOUT_MODE'
export const DEFAULT_COLOR = 'DEFAULT_COLOR'
export const DEFAULT_COLOR_WEAK = 'DEFAULT_COLOR_WEAK'
export const DEFAULT_FIXED_HEADER = 'DEFAULT_FIXED_HEADER'
export const DEFAULT_FIXED_SIDEMENU = 'DEFAULT_FIXED_SIDEMENU'
export const DEFAULT_FIXED_HEADER_HIDDEN = 'DEFAULT_FIXED_HEADER_HIDDEN'
export const DEFAULT_CONTENT_WIDTH_TYPE = 'DEFAULT_CONTENT_WIDTH_TYPE'
export const DEFAULT_MULTI_TAB = 'DEFAULT_MULTI_TAB'

export const CONTENT_WIDTH_TYPE = {
  Fluid: 'Fluid',
  Fixed: 'Fixed'
}

export const WEBSOCKER_METHODS = {
  SOCKET_ONOPEN:'SOCKET_ONOPEN',
  SOCKET_ONCLOSE: 'SOCKET_ONCLOSE',
  SOCKET_ONERROR: 'SOCKET_ONERROR',
  SOCKET_ONMESSAGE: 'SOCKET_ONMESSAGE',
  SOCKET_RECONNECT: 'SOCKET_RECONNECT',
  SOCKET_RECONNECT_ERROR: 'SOCKET_RECONNECT_ERROR'
}